import { listCAAForManagersCase } from './domain/useCases/listCAAForManagersCase'
import { ListCAAForOperationalCase } from './domain/useCases/listCAAForOperationalCase'
import { ListCustomCAAReport } from './domain/useCases/listCustomCAAReport'
import { ListDateCAAReport } from './domain/useCases/listDateCAAReport'
import { ListMonthCAAReport } from './domain/useCases/listMonthCAAReport'
import { ListSemesterCAAReport } from './domain/useCases/listSemesterCAAReport'
import { ListWeekCAAReport } from './domain/useCases/listWeekCAAReport'
import { caaDatasourceAdapter } from './external/datasources/caaDatasourceAdapter'
import { caaRepositoryAdapter } from './infra/repositories/caaRepositoryAdapter'

const repository = caaRepositoryAdapter(caaDatasourceAdapter)

export const caaInstance = {
  listCAAForOperational: ListCAAForOperationalCase(repository),
  listCAAForManagers: listCAAForManagersCase(repository),
  listDateCAAReport: ListDateCAAReport(repository),
  listWeekCAAReport: ListWeekCAAReport(repository),
  listMonthCAAReport: ListMonthCAAReport(repository),
  listSemesterCAAReport: ListSemesterCAAReport(repository),
  listCustomCAAReport: ListCustomCAAReport(repository)
}
